import React, { useRef, useEffect } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import { IAccordionData } from "@/models/IAccordionData";
import Badge from "../badge";

const AccordionWrapper = (props: {
  data: IAccordionData[];
  accordionOpenHeader: string;
  setOpen: (value: string) => void;
}) => {
  // Create a Map to store refs for each accordion item
  const itemRefs = useRef(new Map());

  const handleValueChange = (value: string) => {
    props.setOpen(value);

    // If an item is selected (not being closed)
    if (value) {
      // Get the ref for the selected item
      const itemRef = itemRefs.current.get(value);
      if (itemRef) {
        // Use setTimeout to ensure the accordion has time to expand
        setTimeout(() => {
          itemRef.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 300);
      }
    }
  };

  return (
    <div className="my-8 md:text-2xl text-base">
      <Accordion
        type="single"
        collapsible
        onValueChange={handleValueChange}
        value={props.accordionOpenHeader}
      >
        {props.data.map((el, index) => (
          <AccordionItem
            key={el.header}
            value={el.header}
            ref={(node) => {
              if (node) {
                itemRefs.current.set(el.header, node);
              } else {
                itemRefs.current.delete(el.header);
              }
            }}
          >
            <AccordionTrigger
              className={index === 0 ? "border-t border-border-gray20" : ""}
            >
              <div className="w-full flex items-center justify-between">
                <div data-gtm-id={`item-${32 + index}`}>{el.header}</div>
                <div className="flex gap-2 items-center">
                  {el.type &&
                    el.type.map((type) => (
                      <Badge
                        key={type}
                        className={
                          type === "Pre-clinical"
                            ? "border-border-yellow bg-bg-yellow_orange text-body-text-brown"
                            : "border-border-neutral_sage bg-bg-gray_sage text-body-text"
                        }
                      >
                        {type}
                      </Badge>
                    ))}
                </div>
              </div>
            </AccordionTrigger>
            <AccordionContent>{el.body}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default AccordionWrapper;
